var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "290px",
    height: "124px",
    viewBox: "0 0 290 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 153") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-01",
    transform: "translate(-575.000000, -324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-153",
    transform: "translate(576.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-152",
    transform: "translate(0.000000, 0.947380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.037849,113.917942 C174.250449,105.116562 208.020268,88.5085022 238.722688,62.8805226",
    id: "Stroke-133",
    stroke: "#3F5B77",
    strokeWidth: 1.95999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2877072,106.322452 C48.0305668,120.897012 84.3454462,125.622572 124.581305,117.964852",
    id: "Stroke-134",
    stroke: "#3F5B77",
    strokeWidth: 1.95999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.607311,9.6039015 C6.69397148,25.3182012 -10.6334082,58.5813607 7.37997147,88.4801802",
    id: "Stroke-135",
    stroke: "#3F5B77",
    strokeWidth: 1.95999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9204585,0.445115659 C61.4638185,0.576435656 56.0591186,1.41923564 50.8278787,2.87257562",
    id: "Stroke-136",
    stroke: "#3F5B77",
    strokeWidth: 1.95999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-137",
    fill: "#B7DCFF",
    points: "287.882721 26.2643912 259.955661 68.7248505 250.718181 51.8806108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-138",
    fill: "#B7DCFF",
    points: "229.16122 36.998429 245.477239 45.7184689 287.882819 26.2644892"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-139",
    fill: "#4EAFFF",
    points: "245.477631 45.7184689 243.759691 58.2683487 250.718671 51.8807088 287.883211 26.2644892"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-140",
    stroke: "#3F5B77",
    strokeWidth: 1.95999997,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "287.882721 26.2643912 259.955661 68.7248505 250.718181 51.8806108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-141",
    stroke: "#3F5B77",
    strokeWidth: 1.95999997,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "229.16122 36.998429 245.477239 45.7184689 287.882819 26.2644892"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-142",
    stroke: "#3F5B77",
    strokeWidth: 1.95999997,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "245.477631 45.7184689 243.759691 58.2683487 250.718671 51.8807088 287.883211 26.2644892"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/PaperAirplane.e597350a4a0617c43998124e85639401.svg";
export { ForwardRef as ReactComponent };